// src/data/gyms/Revolution.js
export const Revolution = {
  id: "revolution",
  name: "Revolution Rec Cheer",
  color: "#2563EB", // Bright Rec Blue
  lightColor: "#EFF6FF",
  logo: "🌀",

  teams: [
    {
      id: "codeblackodyssey",
      name: "Code Black Odyssey",
      level: "L1 - Rec Performance Advanced - 10Y",
    },
    {
      id: "codeblacklegacy",
      name: "Code Black Legacy",
      level: "L3.1 - Rec Performance Advanced - 11-18Y",
    },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "8:03 AM",
      teamId: "codeblackodyssey",
      meet: "7:27 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "8:59 AM",
      teamId: "codeblacklegacy",
      meet: "8:23 AM",
      panel: "Hall B",
    },

    // ================= SUNDAY (Dec 14) =================
    // No Sunday performances (One-day Rec competition).
  ],
};
